module.exports = __webpack_public_path__ + "img/music_003.08bcbd06.png";